// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3mPFn","row":"Node_row__m1IP2","label":"Node_label__1KFQr","footer":"Node_footer__2AvAY"};